import { render, staticRenderFns } from "./allPrice.vue?vue&type=template&id=c52b602a&scoped=true"
import script from "./allPrice.vue?vue&type=script&lang=js"
export * from "./allPrice.vue?vue&type=script&lang=js"
import style0 from "./allPrice.vue?vue&type=style&index=0&id=c52b602a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52b602a",
  null
  
)

export default component.exports